import React from 'react';
import Twelvethgrade_k12 from './twelvethgrade_k12';
import Twelvethgrade_k12_subjects from './twelvethgrade_k12_subjects';
const Twelvethgrade_k12scie = () => {
  return (
    <div>
      <Twelvethgrade_k12 />
    <Twelvethgrade_k12_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Science section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Twelvethgrade_k12scie;